var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.id))]),_c('h2',[_vm._v(_vm._s(_vm.subId))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Top")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }